import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import Dialog from '../../../components/dialog/dialog.component'
import Loading from '../../../components/loading/loading.component'
import { connect } from 'react-redux'
import iconNew from '../../../assets/icons/new-light.svg'
import Pagination from '../../../components/pagination/pagination.component'
import './locations.styles.scss'
import Service from './locations.service'
import { FormatDate } from '../../../utils/UIHelper'
import iconDelete from '../../../assets/icons/delete-red.svg'
import iconEdit from '../../../assets/icons/edit-dark.svg'
import DeleteLocation from './components/delete/delete.component'

class Locations extends React.Component {

    constructor(props) {
        super(props)
        this.service = Service(this)
        this.state = this.service.getDefaultState()
    }

    componentDidMount() {
        this.service.loadLocations()
    }

    onPageChange = page => {
        this.setState({
            ...this.state,
            currentPage: page
        }, () => this.service.loadLocations())
    }

    onFilterChange = e => {
        this.setState({
            ...this.state,
            filter: {
                ...this.state.filter,
                value: "",
                [e.target.name]: e.target.value
            }
        })
    }

    onFilterSubmit = e => {
        e.preventDefault()
        this.service.loadLocations()
    }

    toggleShowDelete = location => this.setState({
        ...this.state,
        showDelete: !this.state.showDelete,
        locationToDelete: location
    })

    onDelete = () => this.setState({
        ...this.state,
        showDelete: false,
        locations: this.state.locations.filter(location => location.id !== this.state.locationToDelete.id)
    })

    render() {
        return (
            <>
                {this.state.loading && <Dialog><Loading /></Dialog>}
                {this.state.showDelete && <Dialog><DeleteLocation location={this.state.locationToDelete} onDelete={this.onDelete} onCancel={() => this.toggleShowDelete(null)} /></Dialog>}
                <div className="locations">
                    <div className="header">
                        <h4>Locations</h4>
                        <div className="buttons">
                            <Link className="btn" to="/internet/locations/create"><img alt="" src={iconNew} />New Location</Link>
                        </div>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th>Code</th>
                                <th>Name</th>
                                <th>Cust. Sequence Start</th>
                                <th>Created</th>
                                <th>Updated</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.locations.map((location, key) => <tr key={key}>
                                    <td>{location.code}</td>
                                    <td>{location.name}</td>
                                    <td>{location.customerSequenceStart}</td>
                                    <td>{FormatDate(location.created * 1000)}</td>
                                    <td>{FormatDate(location.updated * 1000)}</td>
                                    <td>
                                        <div className="actions">
                                            <img alt="" src={iconEdit} onClick={() => this.props.history.push('/internet/locations/' + location.id)} />
                                            <img alt="" src={iconDelete} onClick={() => this.toggleShowDelete(location)} />
                                        </div>
                                    </td>
                                </tr>)
                            }
                        </tbody>
                    </table>
                    {
                        this.state.total > 0 && <Pagination totalItemsCount={this.state.total} currentIndex={this.state.currentPage} itemsPerPage={this.state.pageSize} onChange={this.onPageChange} />
                    }
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(Locations))